import { createSelector } from 'reselect';

export const getDocumentation = createSelector(
  (state) =>
    state.projects.scenes.details.scenes.documentation.data.documentation,
  (documentation) => {
    return documentation;
  }
);

export const getDocumentationCount = createSelector(
  (state) =>
    state.projects.scenes.details.scenes.documentation.data.documentationCount,
  (documentationCount) => {
    return documentationCount;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-documentation/store/selectors.js